import { render, staticRenderFns } from "./select_eventstatus.vue?vue&type=template&id=06fef439&scoped=true"
import script from "./select_eventstatus.vue?vue&type=script&lang=js"
export * from "./select_eventstatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fef439",
  null
  
)

export default component.exports